import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A data centre: a long windowless server hall with a roof full of cooling
// units, a louvred intake wall and, alongside, a backup generator and a feed
// transformer. A heavy, always-on electrical load.
const WALL = "#aeb4ba";
const WALL_DK = "#8f969c";
const ROOF = "#73787e";
const CRAC = "#9aa0a6";
const FAN = "#5a6066";
const GEN = "#ffcf3f";
const XFMR = "#878e96";

export const dataCenter = defineModel({
  id: "data-center",
  batchId: "electric",
  name: "Data center",
  tags: ["building", "electric", "power", "compute", "datacenter", "consumer"],
  summary: "A windowless server hall with roof cooling, a genset and transformer.",
  footprint: 1.0,
  parts(): Part[] {
    const parts: Part[] = [
      { geometry: new THREE.BoxGeometry(2.0, 0.1, 1.3), color: "#6f6f74", position: [0, 0.05, 0] },
      // Main hall.
      { geometry: new THREE.BoxGeometry(1.3, 0.66, 1.0), color: WALL, position: [-0.2, 0.43, 0] },
      { geometry: new THREE.BoxGeometry(1.36, 0.06, 1.06), color: ROOF, position: [-0.2, 0.79, 0] },
      // Louvred intake band along the front.
      { geometry: new THREE.BoxGeometry(1.1, 0.2, 0.02), color: WALL_DK, position: [-0.2, 0.36, 0.51] },
    ];
    for (let i = 0; i < 5; i++) {
      parts.push({ geometry: new THREE.BoxGeometry(0.18, 0.16, 0.02), color: "#3a4046", position: [-0.62 + i * 0.22, 0.36, 0.52] });
    }
    // A grid of roof cooling units (CRAC), each with a fan disc.
    for (const x of [-0.5, -0.2, 0.1]) for (const z of [-0.26, 0.26]) {
      parts.push({ geometry: new THREE.BoxGeometry(0.22, 0.1, 0.22), color: CRAC, position: [x, 0.86, z] });
      parts.push({ geometry: new THREE.CylinderGeometry(0.08, 0.08, 0.03, 12), color: FAN, position: [x, 0.92, z] });
    }
    // Door.
    parts.push({ geometry: new THREE.BoxGeometry(0.22, 0.34, 0.02), color: "#3a4046", position: [-0.2, 0.27, 0.51] });
    // Backup genset and feed transformer alongside, on the +X end.
    parts.push(
      { geometry: new THREE.BoxGeometry(0.5, 0.4, 0.34), color: GEN, position: [0.68, 0.3, 0.28] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.2, 8), color: "#4a4a4e", position: [0.5, 0.55, 0.28] },
      { geometry: new THREE.BoxGeometry(0.4, 0.4, 0.34), color: XFMR, position: [0.66, 0.3, -0.28] },
      { geometry: new THREE.BoxGeometry(0.06, 0.4, 0.28), color: "#71787e", position: [0.45, 0.3, -0.28] },
      { geometry: new THREE.CylinderGeometry(0.022, 0.03, 0.14, 8), color: "#9aa6ad", position: [0.66, 0.56, -0.22] },
      { geometry: new THREE.CylinderGeometry(0.022, 0.03, 0.14, 8), color: "#9aa6ad", position: [0.78, 0.56, -0.22] },
    );
    return parts;
  },
  animations: [],
});
